module.exports = fox._r("fonts/activity.woff", __webpack_public_path__ + "_/_/_/root/fonts/3nz_2F5.woff");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/activity.woff
// module id = 387
// module chunks = 4